import React from 'react'
import { Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faQuestion } from '@fortawesome/pro-solid-svg-icons'
import { TooltipIconWrap } from './style'

type GenericTooltipProps = {
  message: string
  placement?: 'top' | 'bottom' | 'left' | 'right'
}

const GenericTooltip = (props: GenericTooltipProps) => {
  const { message, placement = 'bottom' } = props
  return (
    <Tooltip text={message} hasArrow placement={placement}>
      <TooltipIconWrap>
        <span>
          <FontAwesomeIcon icon={faQuestion} size='xs' data-testid='generic-tooltip-icon' />
        </span>
      </TooltipIconWrap>
    </Tooltip>
  )
}

export default GenericTooltip
